import React from 'react';
import { BrowserRouter, Switch } from 'react-router-dom';
import {
  AthleteProfile,
  CheckIn,
  ForgotPassword,
  MemberRegistration,
  MemberRegistrationCreateForm,
  MemberQuestionnaire,
  PostSignUp,
  PublicBooking,
  SignIn,
  Waiver,
} from '../pages';
import PrivateRoute from './privateRoutes';
import PublicRoute from './publicRoutes';
import routeConfig from './routeConfig';
import WaiverPreview from '../pages/common/WaiverPreview';
import MemberQuestionnairePreview from '../pages/Others/MemberQuestionnairePreview/MemberQuestionnairePreview';

const Routes = () => {
  return (
    <BrowserRouter>
      <Switch>
        <PublicRoute
          restricted={true}
          component={SignIn}
          path={[
            '/login',
            '/user-verify/:type/:uuid/:key',
            '/user-verify-phone/:type/:uuid/:key',
            '/auto-login/:type/:uuid/:key',
            '/sign-up',
            '/client-register/:type/:uuid/:key',
          ]}
          exact
        />
        <PublicRoute restricted={true} component={PostSignUp} path="/post-sign-up" exact />
        <PublicRoute restricted={true} component={ForgotPassword} path="/forgot-password" exact />
        <PublicRoute restricted={true} component={PostSignUp} path="/post-sign-up" exact />
        <PublicRoute component={Waiver} path="/sign-waiver" exact />
        {/* //! will be used by coaches */}
        <PublicRoute restricted={false} component={CheckIn} path="/client-self-checkin" exact />
        <PublicRoute
          restricted={false}
          component={MemberRegistration}
          path="/member-registration/:companyId"
          exact
        />
        <PublicRoute
          restricted={false}
          component={MemberRegistrationCreateForm}
          path="/member-registration-form/:companyId"
          exact
        />
        {/* Add the new Member Questionnaire route */}
        <PrivateRoute
          component={MemberQuestionnaire}
          path="/member-questionnaire/:companyId"
          exact
        />
        {/* //! will be used by coaches */}
        <PublicRoute
          restricted={false}
          component={PublicBooking}
          path={['/class-booking', '/public-booking/:id']}
          exact
        />
        <PublicRoute
          restricted={false}
          component={AthleteProfile}
          path={`/${AthleteProfile.route}`}
          exact
        />

        <PublicRoute
          restricted={false}
          component={WaiverPreview}
          path={`/waiver-preview`}
          exact
        />
        <PublicRoute
          restricted={false}
          component={MemberQuestionnairePreview}
          path={"/member-questionnaire-preview"}
          exact
        />
        {routeConfig.map((routes, index) => (
          <PrivateRoute {...routes} key={index} />
        ))}
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
